<template lang="pug">
section.iz-loading__overlay
  object.iz-loading
    embed(:src="src")
</template>

<script>
export default {
  name: 'LoadingCOmponentByIsszx',
  data: () => ({
    author: 'iz',
    // eslint-disable-next-line
    src: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQwIiBoZWlnaHQ9IjE0MCIgdmlld0JveD0iMCAwIDE0MCAxNDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxkZWZzPjxzdHlsZT4KLnN0IHsKICAgIHN0cm9rZS1kYXNoYXJyYXk6IDgyMDsKICAgIHN0cm9rZS1kYXNob2Zmc2V0OiAwOwogICAgLXdlYmtpdC1hbmltYXRpb246IGRhc2ggNS41cyBsaW5lYXIgaW5maW5pdGUgZm9yd2FyZHM7CiAgICAtby1hbmltYXRpb246IGRhc2ggNS41cyBsaW5lYXIgaW5maW5pdGUgZm9yd2FyZHM7CiAgICAtbW96LWFuaW1hdGlvbjogZGFzaCA1LjVzIGxpbmVhciBpbmZpbml0ZSBmb3J3YXJkczsKICAgIGFuaW1hdGlvbjogZGFzaCA1LjVzIGxpbmVhciBpbmZpbml0ZSBmb3J3YXJkczsKfQpALXdlYmtpdC1rZXlmcmFtZXMgZGFzaCB7CiAgICAwJSB7CiAgICAgICAgc3Ryb2tlLWRhc2hvZmZzZXQ6IDgyMDsKICAgIH0KICAgIDUwJSB7CiAgICAgICAgc3Ryb2tlLWRhc2hvZmZzZXQ6IDA7CiAgICB9CiAgICAxMDAlIHsKICAgICAgICBzdHJva2UtZGFzaG9mZnNldDogLTgyMDsKICAgIH0KfQpAa2V5ZnJhbWVzIGRhc2ggewogICAgMCUgewogICAgICAgIHN0cm9rZS1kYXNob2Zmc2V0OiA4MjA7CiAgICB9CiAgICA1MCUgewogICAgICAgIHN0cm9rZS1kYXNob2Zmc2V0OiAwOwogICAgfQogICAgMTAwJSB7CiAgICAgICAgc3Ryb2tlLWRhc2hvZmZzZXQ6IC04MjA7CiAgICB9Cn0KPC9zdHlsZT48L2RlZnM+CjxwYXRoIGNsYXNzPSJzdCIgZD0iTTExNyA1SDIzQzEzLjA1ODkgNSA1IDEzLjA1ODkgNSAyM1YxMTdDNSAxMjYuOTQxIDEzLjA1ODkgMTM1IDIzIDEzNUgxMTdDMTI2Ljk0MSAxMzUgMTM1IDEyNi45NDEgMTM1IDExN1YyM0MxMzUgMTMuMDU4OSAxMjYuOTQxIDUgMTE3IDVaIiBzdHJva2U9IiNmZmRlMDAiIHN0cm9rZS1vcGFjaXR5PSIxIiBzdHJva2Utd2lkdGg9IjEwIi8+CjxwYXRoIGQ9Ik0xMTcgNUgyM0MxMy4wNTg5IDUgNSAxMy4wNTg5IDUgMjNWMTE3QzUgMTI2Ljk0MSAxMy4wNTg5IDEzNSAyMyAxMzVIMTE3QzEyNi45NDEgMTM1IDEzNSAxMjYuOTQxIDEzNSAxMTdWMjNDMTM1IDEzLjA1ODkgMTI2Ljk0MSA1IDExNyA1WiIgc3Ryb2tlPSIjMDAwMDAwIiBzdHJva2Utb3BhY2l0eT0iMC4wNSIgc3Ryb2tlLXdpZHRoPSI4Ii8+Cjwvc3ZnPg==',
  }),
};
</script>

<style lang="scss">
.iz-loading {
  animation: iz-rotate 2s cubic-bezier(0.4, 0.85, 0.65, -0.3) infinite forwards;
  width: 140px;
  height: 140px;
  display: block;
  &__overlay {
    position: absolute;
    top: 0; bottom: 0;
    left: 0; right: 0;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    background-color: #fff;
    z-index: 100;
  }
}
@keyframes iz-rotate {
  0% { transform: rotate(360deg) scale(1.25); }
  50% { transform: rotate(180deg) scale(0.25); }
  100% { transform: rotate(0deg) scale(1.25); }
}
</style>
